// Import Core Components here
import React from "react";

// Import App depedency here
import { Login } from "arv-extends";
import { Input } from "arv-reactcomponents";
import { RegexMethods } from "npmlinks-constants";
import RequiredField from "../../RequiredField";

const { wrapper, getFinalComponent } = Login.MobileNumberInput;

class MobileNumberInput extends wrapper {
  get requiredFieldClassName() {
    const { isValid } = this.state;
    const { className } = this.props;
    return (this.props.required && `${className} ${isValid}`) || "";
  }

  get inputClassName() {
    const { isValid } = this.state;
    const { className } = this.props;
    return (!this.props.required && `${className} ${isValid}`) || "";
  }

  render() {
    const { mobileInputErrorMsg, mobileErrorClass } = this.state;
    const { placeholder, name, maxLength, required } = this.props;
    return (
      <div>
      	<RequiredField className={this.requiredFieldClassName} required={required}>
          <Input
            className={this.inputClassName}
            maxLength={maxLength}
            name={name}
            onBlur={this.onBlur}
            onChange={this.validateMobileNo}
            placeholder={placeholder}
            type="tel"
            value={this.currentMobileNumber}
            ref={values => {
              this.validateMobileNoFieldRef = values;
            }}
            validateWithPattern={RegexMethods.MOBILE_NUMBER_REGEX}
          />
        </RequiredField>
        <div className={`nw-form-err-msg ${mobileErrorClass}`}>
          {mobileInputErrorMsg}
        </div>
      </div>
    );
  }
}

Login.MobileNumberInput.component = getFinalComponent(MobileNumberInput);
